<template>
  <section class="case-creation" v-loading="loading">
    <div class="container-sm">
      <!-- Patient information start here -->
      <div class="case-creation__step case-creation__patient-information pt-15">
        <el-row gutter="15">
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading each-item-creation">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-patient-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Patient Information</h3>
                </div>
              </div>
              <PatientInformation
                v-if="showDob"
                :patientInfo="patientInformation"
                @changeValues="updateData"
                @updateInsurance="updatePatientData"
                ref="patientInformationForm"
              ></PatientInformation>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- Patient information end here -->
      <span class="case-creation__divider"></span>
      <!-- Case information start here -->
      <div class="case-creation__step case-creation__patient-information">
        <el-row gutter="20">
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-case-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Case Information</h3>
                </div>
              </div>
              <div class="case-creation__body pb-0">
                <div class="vue-form">
                  <div
                    style="display: flex; gap: 12px; font-family: sans-serif"
                  >
                    <div>
                      <p style="margin: 0; font-weight: 500">STAT Case</p>
                    </div>
                    <div>
                      <label
                        style="
                          position: relative;
                          display: inline-block;
                          width: 50px;
                          height: 28px;
                        "
                      >
                        <input
                          type="checkbox"
                          v-model="caseInformation.is_stat"
                          style="opacity: 0; width: 0; height: 0"
                        />
                        <span
                          :style="`
                        position: absolute;
                        cursor: pointer;
                        top: 0;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        height: 20px;
                        width: 36px;
                        background-color: ${
                          caseInformation.is_stat ? '#4ade80' : '#f2f2f2'
                        };
                        border : ${
                          caseInformation.is_stat ? '#4ade80' : '#f2f2f2'
                        };
                        border-radius: 34px;
                        transition: 0.4s;
                        display: flex;
                        align-items: center;
                        padding: 0 4px;
                      `"
                        >
                          <span
                            :style="`
                          height: 20px;
                          width: 20px;
                          background-color: ${
                            caseInformation.is_stat ? '#f2f2f2' : 'white'
                          };
                          border-radius: 50%;
                          transition: 0.4s;
                          transform: translateX(${
                            caseInformation.is_stat ? '22px' : '0'
                          });
                        `"
                          ></span>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div style="margin-bottom: 20px">
                    <small style="height: 12px; opacity: 50%"
                      >(only for emergency cases)</small
                    >
                  </div>
                  <el-form :model="caseInformation">
                    <el-row :gutter="15">
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6" v-if="!this.$route.params.order_id">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Case type
                              <span class="star">*</span>
                            </label>
                            <el-select
                              filterable
                              multiple
                              v-model="caseInformation.case_types"
                              placeholder="Select Case type"
                              collapse-tags
                              :multiple-limit="getCaseTypeLimit"
                            >
                              <el-option
                                v-for="(caseType, index) of getCaseTypes"
                                :key="index"
                                :value="caseType.value"
                                :label="caseType.case_name"
                              ></el-option>
                            </el-select>
                            <p class="err error-break">
                              <FormError errorName="case_types"></FormError>
                            </p>
                            <div
                              class="case-select-types"
                              :class="{
                                'active-case-type-error': isError,
                              }"
                            >
                              <p
                                class="selected-case-types"
                                v-for="(
                                  caseTypeVal, index
                                ) in caseInformation.case_types"
                                :key="index"
                              >
                                {{ caseTypeMap[caseTypeVal] }}
                                <span class="test-close">
                                  <el-icon @click="remove(index)">
                                    <circle-close-filled />
                                  </el-icon>
                                </span>
                              </p>
                            </div>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Order Date
                              <span class="star">*</span>
                            </label>
                            <el-date-picker
                              type="date"
                              v-model="caseInformation.order_placed_at"
                              placeholder="MM/DD/YYYY"
                              format="MM-DD-YYYY"
                              value-format="YYYY-MM-DD"
                              :disabled-date="disabledDate"
                            ></el-date-picker>
                            <p class="err">
                              <FormError
                                errorName="order_placed_at"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Ordering Facility
                              <span class="star">*</span>
                            </label>
                            <el-select
                              v-model="caseInformation.hospital"
                              placeholder="Select Ordering Facility"
                              @change="fetchAllPhysiciansByHospital"
                              clearable
                              filterable
                              default-first-option
                              :loading="hospitalsLoading"
                              @focus="fetchHospitalsData"
                            >
                              <el-option
                                v-for="(hospital, index) of hospitalsData.data"
                                :key="index"
                                :value="hospital._id"
                                :label="hospital.name"
                                :disabled="isInactiveStatus(hospital)"
                              >
                                <span style="float: left">
                                  {{
                                    hospital.name + "-" + (hospital.state || "")
                                  }}
                                </span>
                                <span
                                  v-if="isInactiveStatus(hospital)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 10px;
                                  "
                                  >Inactive</span
                                >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="hospital"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Ordering Facility Branch</label>
                            <el-select
                              placeholder="Select Ordering Facility Branch"
                              @change="fetchAllPhysiciansByHospitalBranch"
                              v-model="caseInformation.hospital_branch"
                              clearable
                              filterable
                              default-first-option
                            >
                              <el-option
                                v-for="(hospital, index) of hospitalBranches"
                                :key="index"
                                :value="hospital._id"
                                :label="hospital.display_name"
                                :disabled="isInactiveStatus(hospital)"
                              >
                                <span style="float: left">
                                  {{ hospital.display_name }}
                                </span>
                                <span
                                  v-if="isInactiveStatus(hospital)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 10px;
                                  "
                                  >Inactive</span
                                >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="facility_branch"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Ordering Physician
                              <span class="star">*</span>
                            </label>
                            <el-select
                              placeholder="Select Ordering Physician"
                              v-model="caseInformation.ordering_physician"
                              clearable
                              filterable
                              default-first-option
                            >
                              <el-option
                                v-for="physician in physiciansData.data"
                                :key="physician._id"
                                :label="physician.name"
                                :value="physician._id"
                                :disabled="isInactiveStatus(physician)"
                              >
                                <span style="float: left">
                                  {{ physician.name }}
                                </span>
                                <span
                                  v-if="isInactiveStatus(physician)"
                                  style="
                                    float: right;
                                    color: #eb5757;
                                    font-size: 13px;
                                    padding-left: 15px;
                                  "
                                  >Inactive</span
                                >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="ordering_physician"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Referring Physician</label>
                            <el-select
                              v-model="caseInformation.referring_physician"
                              placeholder="Select Referring Physician"
                              clearable
                              filterable
                              :loading="physicianLoading"
                              @focus="fetchPhysiciansData"
                              default-first-option
                            >
                              <el-option
                                v-for="physician in allReferringPhysicians"
                                :key="physician._id"
                                :label="physician.name"
                                :value="physician._id"
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError
                                errorName="referring_physician"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Bill To
                              <span class="star">*</span>
                            </label>
                            <el-select
                              placeholder="Select Bill To"
                              clearable
                              filterable
                              default-first-option
                              v-model="caseInformation.billing_type"
                            >
                              <el-option
                                class="referring-physician-options"
                                label="INSURANCE"
                                value="INSURANCE"
                              ></el-option>
                              <el-option
                                label="PATIENT"
                                value="PATIENT"
                              ></el-option>
                              <el-option
                                label="CLIENT"
                                value="CLIENT"
                              ></el-option>
                              <el-option
                                v-if="isLabUser"
                                label="LABCORP"
                                value="LABCORP"
                              ></el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="billing_type"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Order Id</label>
                            <el-input
                              type="text"
                              placeholder="Enter Order Id"
                              v-model="caseInformation.order_id"
                              :rows="3"
                              :disabled="this.$route.params.order_id"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="order_id"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="16" :lg="16" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <div
                              style="
                                display: flex;
                                align-items: center;
                                column-gap: 2rem;
                              "
                            >
                              <label for="text">
                                ICD-10 ( Indicative )
                                <span class="star">*</span>
                              </label>
                              <el-checkbox
                                class="el-checkbox-icd"
                                style="
                                  display: flex;
                                  align-items: center;
                                  height: 14px;
                                "
                                v-model="includeAllICDCodes"
                                >Include All ICD Codes</el-checkbox
                              >
                            </div>

                            <div class="ten-icd-group d-flex">
                              <div
                                class="each-input mr-5"
                                v-for="(
                                  icdCode, index
                                ) of caseInformation.icd_10_codesForm"
                                :key="index"
                              >
                                <el-autocomplete
                                  placeholder="CODE"
                                  v-model="icdCode.value"
                                  popper-class="ten-icd-popper"
                                  :fetch-suggestions="getAutoCompleteICDData"
                                  @select="selectICDCode($event, icdCode)"
                                >
                                  <template #default="{ item }">
                                    <div class="icd-dropdown-style">
                                      <span class="code pr-5">
                                        {{ item.code }}
                                      </span>
                                      <span class="desc pl-5">
                                        {{ item.description }}
                                      </span>
                                    </div>
                                  </template>
                                </el-autocomplete>
                              </div>
                            </div>
                            <p class="err">
                              <FormError errorName="icd_10_codes"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">
                              Collection Date & Time
                              <span class="star">*</span>
                            </label>
                            <el-date-picker
                              type="datetime"
                              v-model="caseInformation.collection_date"
                              placeholder="MM-DD-YYYY HH:MM AM"
                              format="MM-DD-YYYY hh:mm A"
                              :default-time="defaultTime"
                            ></el-date-picker>

                            <!-- :disabled-date="disabledDate"-->

                            <p class="err">
                              <FormError
                                errorName="collection_date"
                              ></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>

                      <el-col :xl="4" :lg="4" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text">Temperature</label>
                            <el-input
                              type="text"
                              placeholder="Enter Temperature"
                              v-model="caseInformation.temperature"
                              :rows="3"
                            ></el-input>
                            <p class="err">
                              <FormError errorName="temperature"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                      <el-col :xl="3" :lg="3" :md="3" :sm="6" :xs="6">
                        <div class="case-creation__input">
                          <el-form-item>
                            <label for="text"
                              >Fasting
                              <span class="star">*</span>
                            </label>
                            <el-select
                              v-model="caseInformation.is_fasting"
                              clearable
                            >
                              <el-option
                                v-for="item in fastingOptions"
                                :key="item.value"
                                :value="item.value"
                                :label="item.label"
                              >
                              </el-option>
                            </el-select>
                            <p class="err">
                              <FormError errorName="is_fasting"></FormError>
                            </p>
                          </el-form-item>
                        </div>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- Case information end here -->
      <span class="case-creation__divider"></span>
      <!-- Test information start here -->
      <div class="case-creation__step case-creation__test-information">
        <div class="case-creation__card">
          <div class="text-information-card">
            <div class="case-creation__heading border-bottom-none">
              <div class="title-with-icon">
                <span class="icon">
                  <img
                    src="@/assets/images/icons/icon-test-info.svg"
                    alt="icon"
                    class="img-fluid"
                  />
                </span>
                <h3 class="title">Order Codes</h3>
              </div>
            </div>
            <div class="test-information-header">
              <p>You can manage order codes here</p>
            </div>
          </div>
        </div>
      </div>
      <div class="selected-tests-information" v-if="hasOrderCodes">
        <div class="input-value view-cases order-codes" v-if="hasOrderCodes">
          <ul>
            <li
              v-for="(code, index) in orderCodes"
              :key="`order-code-${code}-${index}`"
            >
              {{ code }}
            </li>
          </ul>
        </div>
      </div>
      <div class="center-error-message" v-if="isTestInfoError">
        <p class="err">
          <FormError errorName="tests_info"></FormError>
        </p>
      </div>
      <!-- Test information end here -->
      <div
        class="case-creation__step case-creation"
        v-if="hasPermission('test_reports', 'update_download_status')"
      >
        <div class="case-creation__card">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-billing-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Additional Notes</h3>
            </div>
          </div>
          <div class="case-creation__body">
            <div class="billing-information-tabs">
              <el-row :gutter="15">
                <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
                  <div class="case-creation__input billing_notes">
                    <label for="text"> Additional Notes </label>
                    <el-input
                      v-model="physician_notes"
                      type="textarea"
                      placeholder="Enter Additional Notes"
                    ></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
      <span class="case-creation__divider"></span>
      <!-- Medications start here -->
      <div class="case-creation__step case-creation__test-information">
        <MedicationsAdd
          v-if="showMedication"
          :medicationsData="medicationsList"
          ref="medicationFormDetails"
          :newCase="checkCaseValidation"
        ></MedicationsAdd>
        <div class="center-error-message" v-if="isMedicationError">
          <p class="err">
            <FormError errorName="medication"></FormError>
          </p>
        </div>
      </div>
      <!-- Medications end here -->
      <!-- Billing information start here -->
      <div
        class="case-creation__step case-creation__billing-information"
        v-if="caseInformation.billing_type == 'INSURANCE'"
      >
        <el-row>
          <el-col :span="24">
            <div class="case-creation__card">
              <div class="case-creation__heading justify-start">
                <div class="title-with-icon">
                  <span class="icon">
                    <img
                      src="@/assets/images/icons/icon-billing-info.svg"
                      alt="icon"
                      class="img-fluid"
                    />
                  </span>
                  <h3 class="title">Billing Information</h3>
                </div>
                <div class="billing_alignmens">
                  <p class="err">
                    <FormError errorName="billing_info"></FormError>
                  </p>
                </div>
              </div>
              <div class="case-creation__billing-information__body">
                <div class="case-creation__tabs billing-information-tabs">
                  <el-tabs
                    v-model="activeName"
                    @tab-click="updateSelectedTabQuery"
                  >
                    <el-tab-pane name="first">
                      <template #label>
                        <span
                          class="inactive-tabs"
                          :class="{ 'active-tabs': hasError }"
                          >primary insurance</span
                        >
                      </template>
                      <PrimaryInsurance
                        v-show="activeName === 'first' && showInsuranceDob"
                        :primaryInsurance="primaryInsuranceForm"
                        :refreshDob="refreshPatientDob"
                        :parentRefs="$refs"
                        ref="primaryInsuranceForm"
                      ></PrimaryInsurance>
                    </el-tab-pane>
                    <el-tab-pane name="second">
                      <template #label>
                        <span
                          class="inactive-tabs"
                          :class="{ 'active-tabs': hasSecondaryErrors }"
                          >Secondary Insurance</span
                        >
                      </template>
                      <SecondaryInsurance
                        v-show="activeName === 'second' && showInsuranceDob"
                        :secondaryInsurance="secondaryInsuranceForm"
                        :parentRefs="$refs"
                        :refreshDob="true"
                        ref="secondaryInsuranceForm"
                        :state="selectedHospitalState"
                        :billTo="caseInformation.billing_type"
                      ></SecondaryInsurance>
                    </el-tab-pane>
                    <el-tab-pane name="third">
                      <template #label>
                        <span
                          class="inactive-tabs"
                          :class="{ 'active-tabs': hasTertiaryErrors }"
                          >Tertiary Insurance</span
                        >
                      </template>
                      <TertiaryInsuranceForm
                        v-show="activeName === 'third' && showInsuranceDob"
                        :tertiaryInsurance="tertiaryInsuranceForm"
                        :parentRefs="$refs"
                        :refreshDob="true"
                        ref="tertiaryInsuranceForm"
                        :state="selectedHospitalState"
                        :billTo="caseInformation.billing_type"
                      ></TertiaryInsuranceForm>
                    </el-tab-pane>
                    <el-tab-pane name="fourth">
                      <template #label>
                        <span
                          class="inactive-tabs"
                          :class="{ 'active-tabs': hasGuarantorErrors }"
                          >Guarantor</span
                        >
                      </template>
                      <GuarantorInsurance
                        v-show="activeName === 'fourth' && showInsuranceDob"
                        :guarantorInsurance="guarantorInsuranceForm"
                        ref="guarantorInsuranceForm"
                        :parentRefs="$refs"
                        :state="selectedHospitalState"
                      ></GuarantorInsurance>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="case-creation__divider"></div>
      <!-- Billing information end here -->
      <div
        class="center-error-message pt-10 pb-20"
        v-if="this.getErrors && this.getErrors.critical_error"
      >
        <p class="err">
          <FormError errorName="critical_error"></FormError>
        </p>
      </div>
      <!-- Action buttons -->
      <div class="case-creation__actions fixed">
        <ul class="list">
          <li>
            <el-button
              type="button"
              class="btn cancel-button"
              @click="goToAllOrders"
              >Cancel</el-button
            >
          </li>
          <li>
            <el-button
              type="button"
              class="btn save-button"
              @click="updatedOrderData"
              >Update</el-button
            >
          </li>
        </ul>
      </div>
      <p class="err">
        <FormError errorName="critical_error"></FormError>
      </p>
    </div>
    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="updateCase"
    >
    </ResonForChange>
    <span class="case-creation__divider"></span>
  </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import caseConstants from "@/config/constants/caseConstants";
import caseDataHelper from "@/mixins/caseDataHelper";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import { startLoading } from "@/helpers/loadingHelper";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
// billing Info
const PrimaryInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/PrimaryInsurance")
);
const SecondaryInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/SecondaryInsurance")
);
const TertiaryInsuranceForm = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/TertiaryInsurance")
);
const GuarantorInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/GuarantorInsurance")
);
import moment from "moment";
import InsuranceHelper from "@/mixins/InsuranceHelper";
import PatientInformation from "@/components/orders/PatientInformationAdd";
import MedicationsAdd from "@/components/orders/MedicationsAdd";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
export default {
  components: {
    ResonForChange,
    FormError,
    PrimaryInsurance,
    SecondaryInsurance,
    TertiaryInsuranceForm,
    GuarantorInsurance,
    PatientInformation,
    MedicationsAdd,
  },
  mixins: [caseDataHelper, AppHelper, InsuranceHelper, UserPermissionsHelper],
  data() {
    return {
      search_case_types: [],
      usersList: [],
      signatureInformation: {
        patient_signature: false,
        physician_signature: false,
        guardian_signature: false,
      },
      sample_collection_type: "",
      toxicologyOrderInformation: {
        patient_name: "",
        patient_dob: "",
        date_of_service: new Date(),
        provider_name: "",
        check_list: [],
        please_explain: "",
        name_of_practice: "",
        name_of_clinician: "",
        clinician_npi: "",
        ordering_clinician_signature: "",
        date: new Date(),
      },
      urinalysisOrderInformation: {
        patient_name: "",
        patient_dob: "",
        date_of_service: new Date(),
        provider_name: "",
        check_list: [],
        please_explain: "",
        name_of_practice: "",
        name_of_clinician: "",
        clinician_npi: "",
        ordering_clinician_signature: "",
        date: new Date(),
      },
      utiOrderInformation: {
        icd_codes: [],
        check_list: [],
        patient_name: "",
        patient_dob: "",
        date_of_service: new Date(),
        others: "",
        name_of_practice: "",
        name_of_clinician: "",
        clinician_npi: "",
        ordering_clinician_signature: "",
        date: new Date(),
      },
      gastroOrderInformation: {
        check_list: [],
        others: "",
      },
      nailOrderInformation: {
        check_list: [],
        others: "",
      },
      covidFluOrderInformation: {
        check_list: [],
        others: "",
      },
      covidOrderInformation: {
        check_list: [],
        others: "",
      },
      rppOrderInformation: {
        check_list: [],
        others: "",
      },
      woundOrderInformation: {
        check_list: [],
        others: "",
      },
      defaultTime: [new Date()],

      page: 1,
      pageSize: 10,
      errorDiloag: false,
      caseUpdate: false,
      newCase: false,
      refreshPatientDob: true,
      existedCaseDetails: {},
      caseInformationDetails: {},

      filterString: "",
      takeReasonDialog: false,
      buttonLoading: false,
      loading: false,
      addtestModelPopup: false,
      modalLoading: false,
      activeName: "first",
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      faxInputValue: "",
      hideTestsDetails: false,

      //case information
      getSpecimenTypes: { ...caseConstants.CASE_TYPE_SPECIMEN_TYPE_MAP },
      fastingOptions: caseConstants.FASTING,
      caseInformation: {
        case_types: [],
        is_stat: false,
        hospital: "",
        hospital_branch: "",
        ordering_physician: "",
        referring_physician: null,
        icd_10_codes: "",
        billing_type: "",
        requisition_order_id: "",
        order_placed_at: "",
        received_date: "",
        collection_date: new Date(),
        temperature: "",
        icd_10_codesForm: [
          {
            sno: 1,
            value: "",
          },
          {
            sno: 2,
            value: "",
          },
          {
            sno: 3,
            value: "",
          },
          {
            sno: 4,
            value: "",
          },
          {
            sno: 5,
            value: "",
          },
          {
            sno: 6,
            value: "",
          },
          {
            sno: 7,
            value: "",
          },
          {
            sno: 8,
            value: "",
          },
          {
            sno: 9,
            value: "",
          },
          {
            sno: 10,
            value: "",
          },
        ],
        is_fasting: "",
      },
      sampleTypesList: "",
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: [],
      },
      selectedTab: null,
      hospitalBranches: [],
      allReferringPhysicians: [],
      show: false,
      showDob: false,
      showMedication: false,
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },

      allTests: [],
      orderId: "",
      primaryInsuranceForm: {},
      secondaryInsuranceForm: {},
      tertiaryInsuranceForm: {},
      guarantorInsuranceForm: {},
      hospitalsData: {},
      physiciansData: {},
      patientInformation: {},
      hospitalsLoading: false,
      physicianLoading: false,
      selectedSampleTypes: "",
      selectedSampleTypes1: "",
      selectedSampleTypes2: "",
      showInsuranceDob: false,
      labdaqFacilityData: {},
      toxicology_ereq_form: [],
      physician_notes: "",
      custom_test_profiles: [],
      medicationsList: [],
      selectedSpecimen: "",
      medicationMappedTestsData: [],
      medicationPopup: false,
      medicationMismatchedData: [],
      icdErrorDialog: false,
      billingErrors: [],
      pecosStatus: null,
      selectedHospitalState: null,
      includeAllICDCodes: false,
      filteredPanels: [],
      specimen_source: [],
      selectedTubeData: [],
      isToggled: false,
      insuranceUploadPayload: null,
    };
  },
  computed: {
    checkCaseValidation() {
      if (this.$route.params.order_id) {
        return false;
      }
      return true;
    },
    hasError() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.primary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasSecondaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.secondary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasTertiaryErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.tertiary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    hasGuarantorErrors() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf("billing_info.insurance.guarantor") !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    ...mapGetters("cases", [
      "getMedicationCreateStatus",
      "getAllMedications",
      "getAllSampleTypes",
      "getMedicationTests",
    ]),
    ...mapGetters("orders", [
      "getCaseInformation",
      "getCaseInformationValidationErrors",
      "getCaseInformationSaveStatus",
      "getOrderMedicationUpdateStatus",
      "getPatientInformationValidationErrors",
      "getLocalPatient",
      "getCaseInformationValidationErrorsCode",
      "getCaseUpdateInformationValidationErrorsCode",
      "getSingleOrderTestsInfo",
      "getAttachmentUploadStatusUpdated",
      "getFileUploadURLForAttachments",
      "getAttachmentUploadStatus",
      "getFileUploadRefIdForAttachment",
    ]),
    ...mapGetters("icd10Codes", ["getAllIcd10Codes"]),
    isTestInfoError() {
      if (this.getErrors && this.getErrors.tests_info) {
        return true;
      }
      return false;
    },
    isMedicationError() {
      if (this.getErrors && this.getErrors.medication) {
        return true;
      }
      return false;
    },
    isError() {
      if (this.getErrors && this.getErrors.order_placed_at) {
        return true;
      }
      if (
        this.getCaseInformationValidationErrorsCode &&
        this.getCaseInformationValidationErrorsCode.error_code ==
          "GENETIC_VALIDATE"
      ) {
        return true;
      }
      return false;
    },
    ...mapGetters("auth", ["getAuthenticatedUser", "getUserPrimaryLabId"]),
    ...mapGetters("errors", ["getErrors", "getError"]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", [
      "getAllPhysicians",
      "getPhysicianSignatureUpdate",
      "getSinglePhysician",
    ]),
    ...mapGetters("branches", ["getAllBranches"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupWiseTestsData",
      "getNewLabGroupPanelTests",
    ]),
    getCaseTypes() {
      return this.search_case_types;
    },
    getCaseTypeLimit() {
      return 4;
    },
    orderCodes() {
      return this.getCaseInformation?.order_codes || [];
    },
    hasOrderCodes() {
      return this.orderCodes.length > 0;
    },
  },
  async mounted() {
    await this.loadInitData();
    await this.$store.dispatch("labTests/fetchLabGroupWiseTests", {
      lab_id: this.getUserPrimaryLabId,
    });
  },
  methods: {
    async remove(index) {
      this.caseInformation.case_types.splice(index, 1);
    },
    getLabCaseTypes() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        this.search_case_types = this.getUserBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      } else {
        this.search_case_types = this.getLabBasedCaseTypes(
          caseConstants.CASE_TYPES_DATA
        );
      }
    },
    async fetchPhysicianDetails() {
      await this.$store.dispatch("physicians/fetchSinglePhysician", {
        physician_id: this.caseInformation.ordering_physician,
      });
      if (this.getSinglePhysician && this.getSinglePhysician.signature) {
        this.physician_sign = this.getSinglePhysician.signature;
      } else {
        this.physician_sign = "";
      }
    },
    updatePatientData(data) {
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.primary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.primary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.secondary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.secondary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.tertiary_insurance
      ) {
        this.showInsuranceDob = false;

        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
          data.billing_info.insurance.tertiary_insurance
        );
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.billing_info &&
        data.billing_info.insurance &&
        data.billing_info.insurance.guarantor
      ) {
        this.showInsuranceDob = false;
        setTimeout(() => {
          this.showInsuranceDob = true;
        }, 100);
        this.guarantorInsuranceForm = data.billing_info.insurance.guarantor;
      }
      if (
        data &&
        Object.keys(data).length != 0 &&
        data.medication &&
        data.medication.length != 0
      ) {
        this.showMedication = false;
        setTimeout(() => {
          this.showMedication = true;
        }, 100);
        this.medicationsList = data.medication;
      } else {
        this.showMedication = false;
        setTimeout(() => {
          this.showMedication = true;
        }, 100);
        this.medicationsList = [];
      }
    },
    async fetchHospitalsData() {
      this.hospitalsLoading = true;
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalsLoading = false;
    },
    async fetchPhysiciansData() {
      this.physicianLoading = true;
      await this.$store.dispatch("physicians/fetchAllPhysicians", {
        get_all: true,
      });
      this.allReferringPhysicians =
        this.getAllPhysicians &&
        this.getAllPhysicians.data &&
        this.getAllPhysicians.data.length
          ? this.getAllPhysicians.data
          : [];
      this.physicianLoading = false;
    },
    async loadInitData() {
      const loading = startLoading();
      try {
        if (this.$route.params.order_id) {
          await this.checkCaseInformation();
          this.show = true;
        } else {
          this.loading = false;
          this.caseForm = true;
        }
        await this.$store.dispatch("help/fetchAllStates");
        this.showDob = true;
        this.showInsuranceDob = true;
        this.showMedication = true;
        this.caseInformation.lab = this.getUserPrimaryLabId;
        await this.getLabCaseTypes();
        loading.close();
      } catch (err) {
        loading.close();
      }
    },
    parseInsuranceForm(insuranceData) {
      let params = { ...insuranceData };
      if (params.date_of_birth) {
        params.date_of_birth = moment(params.date_of_birth).format(
          "YYYY-MM-DD"
        );
      }
      // filtering the object
      // removing non entered values
      Object.keys(params).forEach((keyValue) => {
        if (!params[keyValue]) {
          delete params[keyValue];
        }
      });
      return params;
    },
    prepreDataFromFormData() {
      let patientFormInfo = this.$refs["patientInformationForm"];

      let params = this.parseCaseInfo();

      let patientInfo = patientFormInfo.formatPatientInfo();

      let insurance = {};

      let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
      if (primaryInsuranceFormDetails) {
        let primaryInsuranceFormData = this.parseInsuranceForm(
          primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
        );
        if (Object.keys(primaryInsuranceFormData).length) {
          insurance.primary_insurance = primaryInsuranceFormData;
        }
      } else {
        if (this.primaryInsuranceForm) {
          if (Object.keys(this.primaryInsuranceForm).length) {
            insurance.primary_insurance = this.primaryInsuranceForm;
          }
        }
      }
      let secondaryInsuranceFormDetails = this.$refs["secondaryInsuranceForm"];
      if (secondaryInsuranceFormDetails) {
        let secondaryInsuranceFormData = this.parseInsuranceForm(
          secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
        );

        if (Object.keys(secondaryInsuranceFormData).length) {
          insurance.secondary_insurance = secondaryInsuranceFormData;
        }
      } else if (this.secondaryInsuranceForm) {
        if (Object.keys(this.secondaryInsuranceForm).length) {
          insurance.secondary_insurance = this.secondaryInsuranceForm;
        }
      }

      let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
      if (tertiaryInsuranceFormDetails) {
        let tertiaryInsuranceFormData = this.parseInsuranceForm(
          tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
        );

        if (Object.keys(tertiaryInsuranceFormData).length) {
          insurance.tertiary_insurance = tertiaryInsuranceFormData;
        }
      } else if (this.tertiaryInsuranceForm) {
        if (Object.keys(this.tertiaryInsuranceForm).length) {
          insurance.tertiary_insurance = this.tertiaryInsuranceForm;
        }
      }

      let guarantorInsuranceFormDetails = this.$refs["guarantorInsuranceForm"];
      if (guarantorInsuranceFormDetails) {
        let guarantorInsuranceFormData = this.parseInsuranceForm(
          guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
        );

        if (Object.keys(guarantorInsuranceFormData).length) {
          insurance.guarantor = guarantorInsuranceFormData;
        }
      } else if (this.guarantorInsuranceForm) {
        if (Object.keys(this.guarantorInsuranceForm).length) {
          insurance.guarantor = this.guarantorInsuranceForm;
        }
      }
      if (
        Object.keys(insurance).length > 0 &&
        this.caseInformation.billing_type == "INSURANCE"
      ) {
        params.billing_info = { insurance: insurance };
      } else {
        params.billing_info = {};
      }
      params.patient_info = patientInfo;
      let medicationFormDetails = this.$refs["medicationFormDetails"];
      if (medicationFormDetails) {
        params.medication = medicationFormDetails.getMedicationsList();
      }
      if (this.physician_notes) {
        params.physician_notes = this.physician_notes;
      }
      if (
        this.caseInformation.is_fasting == true ||
        this.caseInformation.is_fasting == false
      ) {
        params.is_fasting = this.caseInformation.is_fasting;
      }
      params.toxicology_ereq_form = [];

      params.is_stat = this.caseInformation.is_stat;

      return params;
    },
    parseCaseInfo() {
      let dataToParse = {
        case_types: this.caseInformation.case_types,
        lab: this.caseInformation.lab,
        order_placed_at: this.caseInformation.order_placed_at
          ? this.caseInformation.order_placed_at + "T00:00:00.000Z"
          : "",
        hospital: this.caseInformation.hospital,
        is_stat: this.caseInformation.is_stat,
        icd_10_codes: this.caseInformation.icd_10_codesForm
          .filter((e) => e.value)
          .map((e) => e.value),
        ordering_physician: this.caseInformation.ordering_physician,
        referring_physician: this.caseInformation.referring_physician || null,
        hospital_branch: this.caseInformation.hospital_branch
          ? this.caseInformation.hospital_branch
          : null,
        billing_type: this.caseInformation.billing_type,
        order_id: this.caseInformation.order_id,
        collection_date: this.convertToLabUTC(
          this.caseInformation.collection_date
        ),
        temperature: this.caseInformation.temperature,
      };
      if (this.caseInformation.sample_collection_type) {
        dataToParse.sample_collection_type =
          this.caseInformation.sample_collection_type;
      }
      return dataToParse;
    },
    updateSelectedTabQuery() {
      const primaryInfo = this.$refs["primaryInsuranceForm"];
      if (primaryInfo) {
        this.primaryInsuranceForm = this.parseInsuranceForm(
          primaryInfo.getPrimaryInsuranceFormData()
        );
      }
      const secondaryInfo = this.$refs["secondaryInsuranceForm"];
      if (secondaryInfo) {
        this.secondaryInsuranceForm = this.parseInsuranceForm(
          secondaryInfo.getSecondaryInsuranceFormData()
        );
      }
      const teritaryInfo = this.$refs["tertiaryInsuranceForm"];
      if (teritaryInfo) {
        this.tertiaryInsuranceForm = this.parseInsuranceForm(
          teritaryInfo.getTertiaryInsuranceFormData()
        );
      }
      const gaurantorInfo = this.$refs["guarantorInsuranceForm"];
      if (gaurantorInfo) {
        this.guarantorInsuranceForm = this.parseInsuranceForm(
          gaurantorInfo.getGuarantorInsuranceFormData()
        );
      }
    },
    async handleClose(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });

      window.location.reload();
    },
    async handlePopUp(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear", null, { root: true });
    },
    async newCaseCreation(response) {
      this.errorDiloag = response;
      await this.$store.commit("errors/clear");
      window.location.reload();
    },
    async approveCase(response) {
      try {
        this.errorDiloag = response;
        await this.$store.commit("errors/clear");
        this.loading = true;
        let params = this.prepreDataFromFormData();
        params.auto_approved = true;
        params.billing_acknowledged = true;
        await this.$store.dispatch("cases/addNewCase", params);
        if (this.getCaseCreationStatus) {
          successNotification("New Case Created Successfully");
          this.goBack();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification(this.getError || "Error while creating New Case");
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async askReason() {
      this.takeReasonDialog = true;
    },
    async updatedOrderData() {
      const orderId = this.$route.params.order_id;
      if (orderId) {
        this.askReason();
      }
    },
    async updateCase(reason) {
      this.updateNewOrder(reason);
    },
    async updateNewOrder(reason) {
      try {
        this.loading = true;
        let params = this.prepreDataFromFormData();
        const orderId = this.$route.params.order_id;
        params.order_id = orderId;
        params.data_update_reason = reason;
        await this.$store.dispatch("orders/updateOrderDetails", params);
        this.caseUpdate = true;
        if (this.getCaseInformationSaveStatus) {
          successNotification("Order Updated Successfully");
          this.goBack();
        } else if (this.getErrors) {
          this.scrollToFirstError();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification(this.getError || "Error while updating Order");
          }
        }
        this.loading = false;
        this.takeReasonDialog = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    scrollToFirstError() {
      let el = this.$el.getElementsByClassName("err")[0];

      if (el) {
        el.scrollIntoView({ block: "center" });
      }
    },
    goBack() {
      if (
        this.$route.params &&
        this.$route.params.order_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "ActiveOrders",
          query: { ...this.$route.query, redirectRoute: this.$route.name },
        });
      }
    },
    async fetchAllPhysiciansByHospital(hospital) {
      try {
        if (Object.keys(this.hospitalsData).length > 0) {
          const selectedHospital = this.hospitalsData.data.find(
            (hospitalId) => hospitalId._id === hospital
          );
          if (selectedHospital) {
            // Retrieve the state from the selected hospital object
            this.selectedHospitalState = selectedHospital.state;
          }
        } // Print the selected hospital object to the console
        if (Object.keys(this.labdaqFacilityData).length > 0) {
          const selectedHospital = this.labdaqFacilityData.find(
            (hospitalId) => hospitalId._id === hospital
          );
          if (selectedHospital) {
            // Retrieve the state from the selected hospital object
            this.selectedHospitalState = selectedHospital.state;
          }
        } //
        this.caseInformation.ordering_physician = undefined;
        this.caseInformation.hospital_branch = null;
        this.physician_sign = null;
        let params = {
          hospital,
          get_all: true,
        };
        await this.$store.dispatch("physicians/fetchAllPhysicians", params);
        if (this.getAllPhysicians) {
          this.physiciansData = JSON.parse(
            JSON.stringify(this.getAllPhysicians)
          );
        }
        await this.$store.dispatch("branches/fetchAllBranches", {
          hospital_id: hospital,
          get_all: true,
        });
        this.hospitalBranches = this.getAllBranches.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchAllPhysiciansByHospitalBranch(hospitalBranch) {
      try {
        this.caseInformation.ordering_physician = undefined;

        if (hospitalBranch) {
          let params = {
            hospital_branch: hospitalBranch,
            get_all: true,
          };
          await this.$store.dispatch("physicians/fetchAllPhysicians", params);
          this.physiciansData = JSON.parse(
            JSON.stringify(this.getAllPhysicians)
          );
        } else {
          this.fetchAllPhysiciansByHospital(this.caseInformation.hospital);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAutoCompleteICDData(searchString, cb) {
      try {
        this.search_code = searchString.trim();

        let params = { page: 1, limit: 30 };

        if (searchString) {
          params.search_string = searchString.trim();
        }
        await this.$store.dispatch("icd10Codes/fetAllIcd10Codes", params);
        const allIcdCodes = [];
        (this.getAllIcd10Codes.data || []).forEach((el) => {
          allIcdCodes.push({
            value: el.code + " - " + el.description,
            ...el,
          });
        });

        cb(allIcdCodes || []);
      } catch (err) {
        return cb([]);
      }
    },
    selectICDCode(event, icdCodeData) {
      icdCodeData.value = event.code;
      this.previousSearchString = "";
    },
    // Method to refresh test tube information when tests are removed
    goToAllOrders() {
      if (
        this.$route.params &&
        this.$route.params.order_id &&
        this.$route.query &&
        this.$route.query.redirectRoute
      ) {
        this.$router.go(-1);
      } else {
        this.$confirm("Are you sure to cancel adding new order?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }).then(() => {
          this.$router.push({
            name: "AllOrders",
            query: { ...this.$route.query, redirectRoute: this.$route.name },
          });
        });
      }
    },
    async checkCaseInformation() {
      try {
        this.loading = true;
        this.orderId = this.$route.params.order_id;
        await this.$store.dispatch("orders/fetchCaseInformation", {
          order_id: this.orderId,
        });

        if (!this.getCaseInformation) {
          this.disablePatientInformation = true;
        }
        await this.fetchHospitalsData();
        if (this.getCaseInformation && this.getCaseInformation.hospital) {
          await this.fetchAllPhysiciansByHospital(
            this.getCaseInformation.hospital._id
          );
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.referring_physician
        ) {
          await this.fetchPhysiciansData();
        }
        if (this.getCaseInformation) {
          if (this.getCaseInformation.patient_info) {
            this.patientInformation = {
              ...this.getCaseInformation.patient_info,
            };
          }
          this.setCaseInformationData();
          if (
            this.getCaseInformation &&
            this.getCaseInformation.physician_notes
          ) {
            this.physician_notes = this.getCaseInformation.physician_notes;
          }
          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.secondary_insurance
          ) {
            this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getCaseInformation.billing_info.insurance.secondary_insurance
            );
          }

          if (
            this.caseInformation &&
            this.caseInformation.sample_collection_type
          ) {
            this.caseInformation.sample_collection_type =
              this.getCaseInformation.sample_collection_type;
          }
          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.tertiary_insurance
          ) {
            this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
              this.getCaseInformation.billing_info.insurance.tertiary_insurance
            );
          }
          if (
            this.getCaseInformation &&
            this.getCaseInformation.billing_info &&
            this.getCaseInformation.billing_info.insurance &&
            this.getCaseInformation.billing_info.insurance.guarantor
          ) {
            this.guarantorInsuranceForm =
              this.getCaseInformation.billing_info.insurance.guarantor;
          }
        }
        this.toxicology_ereq_form = this.getCaseInformation.toxicology_ereq_form
          ? this.getCaseInformation.toxicology_ereq_form
          : [];
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    setCaseInformationData() {
      if (
        this.getCaseInformation &&
        Object.keys(this.getCaseInformation) &&
        Object.keys(this.getCaseInformation).length
      ) {
        this.caseInformation.case_types = this.getCaseInformation.case_types;
        this.caseInformation.lab = this.getUserPrimaryLabId
          ? this.getUserPrimaryLabId
          : null;
        if (this.getCaseInformation.order_placed_at) {
          let dateString = this.getCaseInformation.order_placed_at;
          let dateObject = new Date(dateString);

          // Get the date components
          let year = dateObject.getFullYear();
          let month = String(dateObject.getMonth() + 1).padStart(2, "0");
          let day = String(dateObject.getDate()).padStart(2, "0");

          // Create the formatted date string
          let formattedDate = `${year}-${month}-${day}`;

          // Assign the formatted date to this.caseInformation.order_placed_at
          this.caseInformation.order_placed_at = formattedDate;
        }
        if (this.getCaseInformation.collection_date) {
          this.caseInformation.collection_date = this.convertLabUTCToClient(
            this.getCaseInformation.collection_date
          );
        }
        if (this.getCaseInformation.is_stat) {
          this.caseInformation.is_stat = this.getCaseInformation.is_stat;
        }
        this.caseInformation.temperature = this.getCaseInformation.temperature
          ? this.getCaseInformation.temperature
          : null;
        this.caseInformation.hospital = this.getCaseInformation.hospital
          ? this.getCaseInformation.hospital._id
          : null;
        const casePhysician = this.getCaseInformation.ordering_physician;
        if (casePhysician) {
          const physicians = this.physiciansData?.data || [];
          const matched = physicians.find(p => casePhysician.npi_code && p.npi_code === casePhysician.npi_code)
            || physicians.find(p => p._id === casePhysician._id);
          this.caseInformation.ordering_physician = matched?._id || casePhysician._id || null;
        } else {
          this.caseInformation.ordering_physician = null;
        }
        // this.fetchPhysicianDetails();
        this.caseInformation.order_id = this.getCaseInformation.order_id;

        this.caseInformation.referring_physician =
          this.getCaseInformation.referring_physician &&
          this.getCaseInformation.referring_physician._id
            ? this.getCaseInformation.referring_physician._id
            : null;
        this.caseInformation.hospital_branch = this.getCaseInformation
          .hospital_branch
          ? this.getCaseInformation.hospital_branch._id
          : null;
        this.caseInformation.icd_10_codes =
          this.getCaseInformation.icd_10_codes;
        this.caseInformation.billing_type =
          this.getCaseInformation.billing_type;

        this.caseInformation.requisition_order_id =
          this.getCaseInformation.requisition_order_id || "";

        this.caseInformation.patient_info =
          this.getCaseInformation.patient_info;

        if (!this.caseInformation.icd_10_codesForm) {
          this.caseInformation.icd_10_codesForm = [];
        }
        this.caseInformation.icd_10_codes.forEach((el, index) => {
          if (!this.caseInformation.icd_10_codesForm[index]) {
            this.caseInformation.icd_10_codesForm[index] = { sno: index + 1, value: '' };
          }
          this.caseInformation.icd_10_codesForm[index].value = el;
        });
        if (
          this.getCaseInformation &&
          (this.getCaseInformation.is_fasting == false ||
            this.getCaseInformation.is_fasting == true)
        ) {
          this.caseInformation.is_fasting = this.getCaseInformation.is_fasting;
        }
      }
    },
  },
};
</script>
<style lang="scss">
.vue-form {
  .mobile-icon {
    position: relative;
    .el-icon {
      position: absolute;
      right: 2%;
      top: 38%;
      opacity: 0.3;
    }
  }
  .additonal-fax {
    display: flex;
    gap: 20px;
  }
}
.active-tabs {
  color: #eb5757;
  font-weight: 500;
}
</style>